var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.000152588,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 41.499H46.5M34.5 41.499H34.5135M42 47.499H34.5M46.5 47.499H46.4865M49.5 24.999V27.999M31.5 24.999V27.999M27 33.999H54M26.25 40.3635C26.25 33.828 26.25 30.5595 28.128 28.5285C30.006 26.499 33.03 26.499 39.075 26.499H41.925C47.97 26.499 50.994 26.499 52.872 28.53C54.75 30.5595 54.75 33.828 54.75 40.365V41.1345C54.75 47.67 54.75 50.9385 52.872 52.9695C50.994 54.999 47.97 54.999 41.925 54.999H39.075C33.03 54.999 30.006 54.999 28.128 52.968C26.25 50.9385 26.25 47.67 26.25 41.133V40.3635Z",
    stroke: "#002E6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.4e04e3176efa500f8ee92e10b9f9f7f9.svg";
export { ForwardRef as ReactComponent };